<template>
  <div
    :class="{
      'navigation-topbar-mobile__background': true,
      'navigation-topbar-mobile__background--hidden': !activeNav
    }"
    @click="toggleNav()"
  >
    <div
      :class="{
        'navigation-topbar-mobile__flyout-header--back mobile-header-div': true
      }"
    >
      <div class="icon">
        <span class="icon">
          <vue-fontawesome :icon="['fal', 'times']" />
        </span>
      </div>
    </div>
    <div
      :class="{
        'navigation-topbar-mobile__flyout': true,
        'navigation-topbar-mobile__flyout--menu': true,
        'navigation-topbar-mobile__flyout--application': true,
        'navigation-topbar-mobile__flyout--hidden': !activeNav
      }"
    >
      <div
        @click="toggleNav()"
        v-show="!isRollover"
        style="z-index: 1101"
        :class="{
          'navigation-topbar-mobile__flyout': true,
          'navigation-topbar-mobile__flyout--application': true,
          'navigation-topbar-mobile__flyout--hidden': !activeNav
        }"
      >
        <ul
          class="navigation-topbar-mobile__flyout-menu navigation-topbar-mobile__flyout-menu--application"
        >
          <li class="navigation-topbar-mobile__flyout-item">
            <template>
              <span
                class="navigation-topbar-mobile__flyout-link"
                @click="receiveAQuoteClick()"
                >Receive a Quote
                <span
                  class="navigation-topbar-mobile__flyout-icon navigation-topbar-mobile__flyout-icon--right icon icon--arrow-right-thin"
                ></span>
              </span>
            </template>
          </li>
          <li class="navigation-topbar-mobile__flyout-item">
            <router-link
              class="navigation-topbar-mobile__flyout-link"
              to="/faq"
              @click="toggleNav()"
            >
              <span class="navigation-topbar-mobile__flyout-link-title"
                >FAQ</span
              >
              <span
                class="navigation-topbar-mobile__flyout-icon navigation-topbar-mobile__flyout-icon--right icon icon--arrow-right-thin"
              ></span>
            </router-link>
          </li>
          <li class="navigation-topbar-mobile__flyout-item">
            <template>
              <span
                class="navigation-topbar-mobile__flyout-link"
                @click="exploreBenefitsClick()"
                >Explore Benefits
                <span
                  class="navigation-topbar-mobile__flyout-icon navigation-topbar-mobile__flyout-icon--right icon icon--arrow-right-thin"
                ></span>
              </span>
            </template>
          </li>
          <li class="navigation-topbar-mobile__flyout-item">
            <router-link
              class="navigation-topbar-mobile__flyout-link"
              to="/contact-us"
              @click="toggleNav()"
            >
              <span class="navigation-topbar-mobile__flyout-link-title"
                >Contact Us</span
              >
              <span
                class="navigation-topbar-mobile__flyout-icon navigation-topbar-mobile__flyout-icon--right icon icon--arrow-right-thin"
              ></span>
            </router-link>
          </li>
        </ul>
        <ul
          class="navigation-topbar-mobile__flyout-menu navigation-topbar-mobile__flyout-menu--porscheid"
        >
          <li
            class="navigation-topbar-mobile__flyout-item navigation-topbar-mobile__flyout-item--porschecom"
          >
            <a
              href="https://www.porsche.com/usa/"
              class="navigation-topbar-mobile__flyout-link"
              target="_blank"
            >
              <span class="navigation-topbar-mobile__flyout-link-title"
                >Porscheusa.com</span
              >
              <span
                class="navigation-topbar-mobile__flyout-icon navigation-topbar-mobile__flyout-icon--right icon icon--arrow-right-thin"
              ></span>
            </a>
          </li>
          <li
            class="navigation-topbar-mobile__flyout-item navigation-topbar-mobile__flyout-item--myporsche"
          >
            <a
              href="https://my.porsche.com/core/us/en_US/home"
              class="navigation-topbar-mobile__flyout-link"
              target="_blank"
            >
              <span class="navigation-topbar-mobile__flyout-link-title"
                >My Porsche</span
              >
              <span
                class="navigation-topbar-mobile__flyout-icon navigation-topbar-mobile__flyout-icon--right icon icon--arrow-right-thin"
              ></span>
            </a>
          </li>
          <li
            class="navigation-topbar-mobile__flyout-item navigation-topbar-mobile__flyout-item--thirdtab navigation-topbar-mobile__flyout-item--hidden"
          >
            <a href="#" class="navigation-topbar-mobile__flyout-link">
              <span class="navigation-topbar-mobile__flyout-link-title"></span>
              <span
                class="navigation-topbar-mobile__flyout-icon navigation-topbar-mobile__flyout-icon--right icon icon--arrow-right-thin"
              ></span>
            </a>
          </li>
        </ul>
        <div
          class="navigation-topbar-mobile__flyout-footer navigation-topbar-mobile__flyout-footer--hidden"
        >
          <ul class="navigation-topbar-mobile__flyout-footer-nav"></ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnchorRouterLink from 'vue-anchor-router-link';
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'NavigationMenu',
  components: {
    AnchorRouterLink
  },
  props: {},
  model: {
    event: 'toggleNav'
  },
  methods: {
    ...mapActions(['toggleNav', 'logOut']),
    ...mapMutations(['toggleLoader']),
    invokeLogOut: function() {
      this.toggleLoader({
        loaderText: 'Loading...'
      });
      this.logOut()
        .then(() => {
          this.toggleLoader();
          this.$router.push('/');
        })
        .catch(() => {
          this.toggleLoader();
        });
    },
    exploreBenefitsClick() {
      console.log(document.getElementById('exploring-benefits'));
      this.showBenefitsSubmenu = false;
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
      setTimeout(() => {
        this.toggleNav(true);
        const container = document.getElementById('exploring-benefits');
        container.scrollIntoView({ behavior: 'smooth' });
        // container.scrollIntoView({ behavior: 'smooth' });
        // document.getElementById('exploring-benefits').scrollTo(0,0)
      }, 150);
    },
    receiveAQuoteClick() {
      this.toggleNav(true);
      if (this.$route.path !== '/receive-a-quote') {
        this.$router.push('/receive-a-quote');
        setTimeout(() => {
          let container = document.getElementById('quote-container');
          container.scrollIntoView({ behavior: 'smooth' });
        }, 200);
      }
    }
  },
  computed: {
    ...mapGetters(['activeNav', 'user', 'isLoggedIn', 'isRollover'])
  }
};
</script>

<style lang="scss" scoped>
.navigation-flyout {
  display: none;
}
a {
  color: #000;
  text-decoration: none;
}

ul {
  list-style: none;
  margin: 0;
}

.icon {
  font-size: 1.125rem;
  vertical-align: middle;
  cursor: pointer;
  font-family: pag-iconfont;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
}

.mobile-header-div {
  justify-content: space-between;
}

.navigation-topbar-mobile {
  padding-left: 3%;
  padding-right: 3%;
  position: relative;

  @media (min-width: 1080px) {
    display: none;
  }

  &__flyout-header--back {
    position: absolute;
    left: calc(40% + 0.5rem);
    color: $base;
    top: 0.5rem;
  }

  &__flyout-header--back,
  &__flyout-link,
  &__link {
    cursor: pointer;
  }

  &__icon--active,
  &__icon:hover,
  &__link-title--active {
    color: $primary;
  }

  &__crest {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0.375rem;
    width: 6.375rem;
    height: 5rem;
    z-index: 1;
  }

  &__logo {
    display: block;
  }

  &__image {
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url(https://cdn.ui.porsche.com/porsche-design-system/crest/porsche-crest.min.8a292fbd35a5155789ddd011585e05c4@2x.png);
    width: 30px;
    height: 40px;

    @media only screen and (-webkit-min-device-pixel-ratio: 2),
      not all,
      only screen and (min-resolution: 2dppx),
      only screen and (min-resolution: 192dpi) {
      background-image: url(https://cdn.ui.porsche.com/porsche-design-system/crest/porsche-crest.min.8a292fbd35a5155789ddd011585e05c4@2x.png);
    }
  }

  &__items {
    float: right;
    height: 100%;
  }

  &__item {
    display: inline-block;
    position: relative;
    padding-left: 1.125rem;
    padding-right: 1.125rem;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  }

  &__background--hidden,
  &__crest--hidden,
  &__flyout--hidden,
  &__flyout-badge--hidden,
  &__flyout-footer--hidden,
  &__flyout-icon--hidden,
  &__flyout-item--hidden,
  &__item--hidden {
    transform: translateX(-100%);
    transition: opacity 0.4s cubic-bezier(0, 0, 0.2, 1),
      transform 0.4s cubic-bezier(0, 0, 0.2, 1);
    display: none !important;
  }

  &__link {
    display: flex;
    line-height: 4rem;
    align-items: center;
  }

  &__link-icon {
    height: 4rem;
    width: 1.5em;
    margin-left: 1em;
  }

  &__background {
    z-index: 301;
    background-color: #00000099;
    backdrop-filter: blur(32px);
    opacity: 1;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100vw;
    overflow-y: auto;
    transform: translateX(0);
    transition: opacity 0.25s cubic-bezier(0.4, 0, 0.5, 1),
      transform 0.25s cubic-bezier(0.4, 0, 0.5, 1);
  }

  &__flyout {
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    overflow-y: auto;
    width: 40%;

    @media (max-width: 480px) {
      width: 100vw;
    }
  }

  &__flyout-header {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex-direction: row;
    background-color: $base;
    box-sizing: border-box;
    width: 100%;
    height: 4rem;
    padding-left: 3%;
    padding-right: 3%;
  }

  &__icon {
    font-size: 1.125rem;
    vertical-align: middle;
    cursor: pointer;
  }

  &__headline {
    font-size: 1rem;
    line-height: 1.5rem;
    color: #000;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
  }

  &__flyout-menu {
    padding: 0;

    &--porscheid {
      margin-top: 1.875rem;
    }
  }

  &__flyout-item {
    position: relative;

    &::after {
      content: '';
      width: 94%;
      height: 1px;
      background: $contrast-low;
      position: absolute;
      bottom: 0;
      left: 3%;
    }
  }

  &__flyout-link {
    color: $primary;
    font-size: 1rem;
    line-height: 1.5rem;
    text-decoration: none;
    display: block;
    padding: 1.25rem 3%;

    &:hover {
      background-color: $surface;
    }
  }

  &__flyout-link-title {
    color: $primary;
  }

  &__flyout-link-badge--messages {
    color: $primary;
  }

  &__flyout-icon--right {
    color: $primary;
    float: right;
    margin-top: 0.1875rem;
    font-size: 0.875rem;
  }

  &__flyout-footer {
    background-color: #196a99;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 8.75rem;
  }

  &__flyout-footer-nav {
    width: 100%;
    height: 100%;
  }
}

.topnav-backarrow-box {
  width: 25%;
}
.mobile-menu-user-name {
  width: auto;
}

.show-in-center {
  justify-content: flex-start !important;

  .mobile-heading {
    align-items: center;
  }
}
</style>
